module.exports = __webpack_public_path__ + "static/pic06-7677dd8d5710644994212cff0d304c5d.jpg";